import React, { useState, useEffect } from 'react';
import './App.css';

const formatDate = (dateString) => {
  const options = { year: 'numeric', month: '2-digit', day: '2-digit' };
  const date = new Date(dateString);
  return date.toLocaleDateString(undefined, options);
};

const IzinOnay = () => {
  const [izinler, setIzinler] = useState([]);
  const [filteredIzinler, setFilteredIzinler] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [sortField, setSortField] = useState(null);
  const [sortOrder, setSortOrder] = useState('asc');

  const role = localStorage.getItem('role');
  const username = localStorage.getItem('username');

  useEffect(() => {
    fetchIzinler();
  }, [role, username]);

  useEffect(() => {
    const filtered = izinler.filter(izin =>
      izin.RNAME.toLowerCase().includes(searchTerm.toLowerCase())
    );
    setFilteredIzinler(filtered);
  }, [searchTerm, izinler]);

  const fetchIzinler = () => {
    fetch(`https://api.idekod.com.tr/api/izinler?role=${role}&username=${username}&_=${Date.now()}`)
      .then(response => response.json())
      .then(data => setIzinler(Array.isArray(data) ? data : []))
      .catch(error => console.error('İzinler alınırken hata oluştu:', error));
  };

  const handleSort = (field) => {
    const order = sortField === field && sortOrder === 'asc' ? 'desc' : 'asc';
    setSortField(field);
    setSortOrder(order);

    const sorted = [...filteredIzinler].sort((a, b) => {
      if (field === 'RNAME') {
        return order === 'asc' ? a.RNAME.localeCompare(b.RNAME) : b.RNAME.localeCompare(a.RNAME);
      } else if (field === 'BASTAR') {
        return order === 'asc'
          ? new Date(a.BASTAR) - new Date(b.BASTAR)
          : new Date(b.BASTAR) - new Date(a.BASTAR);
      }
      else if (field === 'BITTAR') {
        return order === 'asc'
          ? new Date(a.BASTAR) - new Date(b.BASTAR)
          : new Date(b.BASTAR) - new Date(a.BASTAR);
      }
      
      return 0;
    });
    setFilteredIzinler(sorted);
  };

  const handleOnayla = (telno, PK) => {
    fetch('https://api.idekod.com.tr/api/izin/onayla', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ telno, PK })
    })
      .then(response => response.json())
      .then(data => {
        alert(data.message);
        fetchIzinler();
      })
      .catch(error => console.error('Fetch error:', error));
  };

  const handleIptal = (telno, PK) => {
    const IPTAL_ACK = prompt('İptal nedenini girin:');
    if (IPTAL_ACK) {
      fetch('https://api.idekod.com.tr/api/izin/iptal', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ telno, PK, IPTAL_ACK })
      })
        .then(response => response.json())
        .then(data => {
          alert(data.message);
          fetchIzinler();
        })
        .catch(error => console.error('Fetch error:', error));
    }
  };

  const renderStatus = (onay) => {
    if (onay === 0) return <span className="badge badge--warning">Bekliyor</span>;
    if (onay === 1) return <span className="badge badge--success">Onaylandı</span>;
    return <span className="badge badge--danger">İptal Edildi</span>;
  };

  return (
    <div className="page">
      <div className="page__head">
        <div>
          <h1 className="page__title">İzin Onay</h1>
          <p className="page__subtitle">Bekleyen ve sonuçlanmış izin taleplerini yönetin</p>
        </div>
      </div>

      <div className="card">
        <div className="card__header card__header--row">
          <h2 className="card__title">İzin Talepleri</h2>
          <input
            type="text"
            placeholder="Ada göre ara..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            className="form-control"
            style={{ maxWidth: 280 }}
            aria-label="Ada göre ara"
          />
        </div>

        <div className="table-wrapper">
          <table className="data-table data-table--striped">
            <thead>
              <tr>
                <th className="sortable" onClick={() => handleSort('RNAME')}>Adı Soyadı</th>
                <th>İzin Türü</th>
                <th className="sortable" onClick={() => handleSort('BASTAR')}>Başlangıç Tarihi</th>
                <th className="sortable" onClick={() => handleSort('BITTAR')}>Bitiş Tarihi</th>
                <th>Açıklama</th>
                <th>Durum</th>
                <th>İptal Nedeni</th>
                {role === '1' && <th>İşlemler</th>}
              </tr>
            </thead>
            <tbody>
              {filteredIzinler.map(izin => (
                <tr key={izin.PK}>
                  <td data-label="Adı Soyadı">{izin.RNAME}</td>
                  <td data-label="İzin Türü">{izin.IZINTUR}</td>
                  <td data-label="Başlangıç">{formatDate(izin.BASTAR)}</td>
                  <td data-label="Bitiş">{formatDate(izin.BITTAR)}</td>
                  <td data-label="Açıklama">{izin.ACIKLAMA}</td>
                  <td data-label="Durum">{renderStatus(izin.ONAY)}</td>
                  <td data-label="İptal Nedeni">{izin.IPTAL_ACK}</td>
                  {role === '1' && (
                    <td data-label="İşlemler">
                      <div className="actions-cell">
                        <button
                          onClick={() => handleOnayla(izin.TELNO, izin.PK)}
                          className="btn btn--success btn--sm"
                        >
                          Onayla
                        </button>
                        <button
                          onClick={() => handleIptal(izin.TELNO, izin.PK)}
                          className="btn btn--danger btn--sm"
                        >
                          İptal
                        </button>
                      </div>
                    </td>
                  )}
                </tr>
              ))}
              {filteredIzinler.length === 0 && (
                <tr className="empty-row">
                  <td colSpan={role === '1' ? 8 : 7}>İzin kaydı bulunamadı.</td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default IzinOnay;
